export default class Accessibility {

	constructor() {

		this.DOM = {};
		this.DOM.html = document.documentElement;

	}

	init() {

		this.DOM.element = document.querySelector('.accessibility');

		if (!this.DOM.element)
		{
			return;
		}

		/* label */
		this.DOM.label = this.DOM.element.querySelector('.accessibility__label');

		if (this.DOM.label)
		{
			this.DOM.label.addEventListener('click', () =>
			{
				this.DOM.element.classList.toggle('opened');

			});
		}

		/* overlay */
		this.DOM.overlay = this.DOM.element.querySelector('.accessibility__overlay');

		if (this.DOM.overlay)
		{
			this.DOM.overlay.addEventListener('click', () =>
			{
				this.DOM.element.classList.remove('opened');

			});
		}

		/* anchor */
		this.DOM.anchors = this.DOM.element.querySelectorAll('.accessibility__anchor');

		this.DOM.anchors.forEach(item =>
		{
			const id = item.getAttribute('data-accessibility');

			item.addEventListener('click', () =>
			{
				if (this.DOM.html.classList.contains(id))
				{
					this.clear();
				}
				else
				{
					this.clear();

					item.classList.add('selected');

					this.DOM.html.classList.add(id);
				}

			});
		});

	}

	clear() {

		if (!this.DOM.anchors)
		{
			return;
		}

		this.DOM.anchors.forEach(item =>
		{
			const id = item.getAttribute('data-accessibility');

			item.classList.remove('selected');

			this.DOM.html.classList.remove(id);

		});

	}

	load() {

		this.init();

	}

	unload() {

		this.clear();

	}

}